var map = {
	"./pin_black.png": 518,
	"./pin_blue.png": 519,
	"./pin_blue_bs.png": 520,
	"./pin_blue_bs_dot.png": 521,
	"./pin_brown.png": 522,
	"./pin_darkgrey.png": 523,
	"./pin_green.png": 524,
	"./pin_green_bs.png": 525,
	"./pin_grey.png": 526,
	"./pin_light_brown.png": 527,
	"./pin_lightblue.png": 528,
	"./pin_lightgreen.png": 529,
	"./pin_lightgrey.png": 530,
	"./pin_lightpurple.png": 531,
	"./pin_lightturquoise.png": 532,
	"./pin_orange.png": 533,
	"./pin_pastelblue.png": 534,
	"./pin_pink.png": 535,
	"./pin_purple.png": 536,
	"./pin_red.png": 537,
	"./pin_red_dot.png": 538,
	"./pin_turquoise.png": 539,
	"./pin_yellow.png": 540,
	"./position.png": 515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 517;